import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import ArranqueExpressLanding from "./components/ArranqueExpressLanding";
import ArranqueExpressLandingCat from "./components/ArranqueExpressLanding-cat";
import ArranqueExpressLandingEn from "./components/ArranqueExpressLanding-en";
import Blog from "./components/Blog";
import Dashboard from "./components/Dashboard";
import ArrancarCocheConPinzas from "./components/blog/ArrancarCocheConPinzas";
import ArrancarEmpujandoCoche from "./components/blog/ArrancarEmpujandoCoche";
import QuehacerDespuesArrancar from "./components/blog/QuehacerDespuesArrancar";
import PrevenirBateriaDescargada from "./components/blog/PrevenirBateriaDescargada";
import SintomasBateriaDescargada from "./components/blog/SintomasBateriaDescargada";
import BateriaDescargadaCocheAlquiler from "./components/blog/BateriaDescargadaCocheAlquiler";
import ComoSaberBateriaMuerta from "./components/blog/ComoSaberBateriaMuerta";
import PrecioCambioBateriaBarcelona from "./components/blog/PrecioCambioBateriaBarcelona";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Home = () => {
  const helloWorldApi = async () => {
    try {
      const response = await axios.get(`${API}/`);
      console.log(response.data.message);
    } catch (e) {
      console.error(e, `errored out requesting / api`);
    }
  };

  useEffect(() => {
    helloWorldApi();
  }, []);

  return <ArranqueExpressLanding />;
};

const HomeCat = () => {
  return <ArranqueExpressLandingCat />;
};

const HomeEn = () => {
  return <ArranqueExpressLandingEn />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cat" element={<HomeCat />} />
          <Route path="/en" element={<HomeEn />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/dash" element={<Dashboard />} />
          <Route path="/blog/arrancar-coche-con-pinzas" element={<ArrancarCocheConPinzas />} />
          <Route path="/blog/arrancar-empujando-coche" element={<ArrancarEmpujandoCoche />} />
          <Route path="/blog/que-hacer-despues-arrancar" element={<QuehacerDespuesArrancar />} />
          <Route path="/blog/prevenir-bateria-descargada" element={<PrevenirBateriaDescargada />} />
          <Route path="/blog/sintomas-bateria-descargada" element={<SintomasBateriaDescargada />} />
          <Route path="/blog/bateria-descargada-coche-alquiler" element={<BateriaDescargadaCocheAlquiler />} />
          <Route path="/blog/como-saber-bateria-muerta" element={<ComoSaberBateriaMuerta />} />
          <Route path="/blog/precio-cambio-bateria-barcelona" element={<PrecioCambioBateriaBarcelona />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;